<template>
  <v-btn v-on="$listeners" v-bind="$attrs">
    <v-icon :class="{ ['mr-2']: !noIconPadding }" v-if="icon" :color="color" v-html="icon" />
    <span class="text-none">
      <slot />
    </span>
  </v-btn>
</template>

<script>
  /* eslint-disable */
  export default {
    props: {
      noIconPadding: Boolean,
      icon: String,
      color: {
        type: String,
        default: 'secondary',
      }
    },
  }
</script>